export const MAPBOX_DEFAULT_ZOOM = 5.25;
export const MAPBOX_DEFAULT_MIN_ZOOM = 3;
export const MAPBOX_DEFAULT_CENTER_CORDINATES = [-121.5, 37.5];
export const MAPBOX_STREETS_STYLE = 'mapbox://styles/mapbox/streets-v11?optimize=true';
export const MAPBOX_SATELLITE_STREETS_STYLE = 'mapbox://styles/mapbox/satellite-streets-v11';
export const LEGEND_TOOLTIP_VERY_HIGH_RISK=`Very High:`;
export const LEGEND_TOOLTIP_HIGH_RISK=`High:`;
export const LEGEND_TOOLTIP_MODERATE_RISK=`Moderate:`;
export const LEGEND_TOOLTIP_LOW_RISK=`Low:`;
export const LEGEND_TOOLTIP_VERY_LOW_RISK=`Very Low:`;
export const LOCATION_SEARCH_BOX_PLACEHOLDER='Search daily California wildfire risk at a location';
export const TIMESERIES_FIRE_RISK_DAY_DURATION = 30;
export const TIMESERIES_MEMORIAM_TEXT ='In Memoriam: Dr. Adrian Albert';
